<template>
  <section>
    <div class="container">
      <el-table
        :data="tableData"
        stripe
        @selection-change="checkIds"
        v-loading="loading"
      >
        <el-table-column type="selection" width="65" align="right"></el-table-column>
        <el-table-column prop="prid" v-if="false" label="ID" align="center"></el-table-column>
        <el-table-column prop="" label="用户名" align="center">
          <div slot-scope="scope">
            {{scope.row.user_name}}[{{scope.row.role_name}}]
          </div>
        </el-table-column>
        <el-table-column prop="record_time" label="支付时间" align="center" :formatter="formatTime">
        </el-table-column>
        <el-table-column prop="pay_account" label="支付金额" align="center"></el-table-column>
        <el-table-column prop="pay_type" label="支付方式" align="center">
          <div slot-scope="scope">
            <span v-if="String(scope.row.pay_type) == '0'">微信支付</span>
            <span v-if="String(scope.row.pay_type) == '1'">余额支付</span>
          </div>:formatter="formatTime"
        </el-table-column>
        <el-table-column prop="pay_direction" label="支付方式" align="center">
          <div slot-scope="scope">
            <span v-if="String(scope.row.pay_direction) == '0'">充值</span>
            <span v-if="String(scope.row.pay_direction) == '1'">缴费</span>
          </div>
        </el-table-column>
        <el-table-column prop="pay_des" label="支付备注" align="center"></el-table-column>
      </el-table>
      <!-- 表格底部 -->
      <div class="cms-list-footer">
        <div class="cms-left"></div>
        <!-- 分页组件 -->
        <cms-pagination :total="total" @change="getPages"></cms-pagination>
      </div>
    </div>
  </section>
</template>

<script>
import va from "@/rules";
import listMixins from "@/mixins/list";

export default {
  name: "DevTypeList",
  mixins: [listMixins],
  data() {
    return {
      params: {
        // 只需要业务参数
        // id: '',
        pageNo: "1",
        pageSize: "10"
      },
      isadmin: false
    };
  },
  mounted() {},
  methods: {
    checkIds(val) {
      let ids = [];
      for (let i in val) {
        ids.push(val[i].prid);
      }
      this.ids = ids.join(",");
      this.disabled = !(val.length > 0);
      this.checkedList = val;
    },
    formatTime(row, column, cellValue, index) {
      //修正时间格式，形如2018-10-08 11:10:05
      if(cellValue) {return cellValue.replace("T", " ").substring(0, 19); }
      else{return ''}
    }
  },
  created() {
    this.params.uid=this.$store.state.userInfo.id
    this.initTableData("PayRecord/PagedView", this.params);
    this.loading = false;
    this.isadmin = this.$isAdmin();
  }
};
</script>
